import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import request from '@/lib/axios'
import Pagination from '@/lib/pagination'
import { filterQueryStringParams } from '@/lib/route'
//////////////////////////////////////////////////
////////////////////////////
/////////
// eslint-disable-next-line
import { store } from '@/main'
//////////

const defaultSkippedParams = [ 'query', 'product_type', 'asset', 'per_page', 'page', 'sort', 'contributors' ]

const defaultParams = {
  query: null,
  asset: 'icon',
  product_type: 'item',
  contributors: [],
  categories: [],
  color: null,
  sort: 'relevant',
  pack_uuid: null,
  page: 1,
  price: null
}

// const defaultExtraParams = {
//   icon: {
//     styles: [],
//     icon_grid: null,
//     stroked: null,
//     background_type: null
//   },
//   photo: {
//     width: null,
//     height: null,
//     allowed_usage: null,
//     nsfw: false,
//     orientation: [],
//     ethnicity: [],
//     gender: [],
//     age: [],
//     people: []
//   },
//   illustration: {
//     width: null,
//     height: null,
//     allowed_usage: null,
//     nsfw: false,
//     orientation: []
//   }
// }

export default class SearchService extends Pagination {
  constructor () {
    super()

    this.isLoading = false
    this.styles = []
    this.orientation = []
    this.appliedFilters = []
    this.params = cloneDeep(defaultParams)
    this.requestId = null
  }

  searchQueryStringFilter (params) {
    let result = filterQueryStringParams(params)

    if (result.nsfw === false) {
      delete result.nsfw
    }

    if (isEmpty(params.query) && params.sort === 'relevant') {
      result.sort = 'popular'
    }

    return result
  }

  allParams () {
    return this.searchQueryStringFilter(cloneDeep(this.params))
  }

  setAppliedFilters () {
    let filters = []
    let skippedParams = defaultSkippedParams
    let params = this.allParams()

    for (let property in params) {
      // Skip Param
      if (skippedParams.indexOf(property) !== -1) {
        continue
      }

      let value = params[property]
      if (value instanceof Array) {
        for (var i = 0; i < value.length; i++) {
          filters.push({
            property,
            value: value[i],
            index: i
          })
        }
      } else if (property === 'color') {
        filters.push({
          property,
          value,
          color: true
        })
      } else {
        filters.push({
          property,
          value
        })
      }
    }
    this.appliedFilters = filters
  }

  async fetch (append = false) {
    this.isLoading = true
    this.requestId = Math.random()

    // If request query is null then sort by latest
    // if (isEmpty(this.params.query)) {
    //   this.params.sort = 'latest'
    // }

    // Clear Data
    if (!append) {
      // Clear the selected item if exists
      // eslint-disable-next-line
/////////////////////////
//////////////////////////////////
/////////////////////////////////
//////////
      this.params.page = 1
      this.setData([], false)
    }

    // Giving current request as an Id
    const currentRequest = Number(this.requestId)

    this.setAppliedFilters()
    let results = await request({
      route: 'search',
      params: this.allParams()
    })

    // Checking current request with stored current Id
    if (currentRequest === this.requestId) {
      let type = this.params.product_type === 'item' ? 'items' : 'packs'
      this.setData(results.data.response[type], append)
      this.setPagination(results.data.response[type])
      this.setStyles(results.data.response.aggregations.styles)
      this.setOrientation(results.data.response.aggregations.orientation)
      this.isLoading = false
    } else {
      console.log('Skipped Exising Request', currentRequest)
    }
  }

  async fetchNextPage () {
    this.params.page++
    await this.fetch(true)
  }

  setData (data, append) {
    if (append) {
      this.data = [
        ...this.data,
        ...data.data
      ]
    } else {
      this.data = data.data
    }
  }

  setStyles (data) {
    this.styles = data
  }

  setOrientation (data) {
    this.orientation = data
  }

  reset (params) {
    this.params = {
      ...cloneDeep(defaultParams),
      ...params
    }
    this.data = []
  }

  clearFilters () {
    this.reset()
    this.fetch()
  }
}
